import React from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown} from "react-bootstrap";
import "./StationLocations.scss";
import PropertyMap from "@Components/PropertyMap/PropertyMap"
import StationLocationImgDesktop from "../../../images/propertydetails/station-location-d.jpg"
import StationLocationImgTablet from "../../../images/propertydetails/station-location-t.jpg"
import StationLocationImgMobile from "../../../images/propertydetails/station-location-m.jpg"
import TransparentList from "@Components/map/transparent-list"
const StationLocations = (props) => {


  
    return (
        <React.Fragment>
            <div ref={props.mapRef} />
            {/* {props.property_latitude} - {props.property_longitude} */}
           <section  className="section-station-locations">
               <Container>
                   <div className="station-locations-row">
                   
                   <div className="location-map 456">
                   <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                   {props.property_latitude && props.property_longitude &&
                    <>
                        <PropertyMap
                            property_map_lat={props.property_latitude}
                            property_map_lng={props.property_longitude}
                        />
                    </>
                   }
                   {/* <picture>
                        <source media="(min-width:992px)" srcSet={StationLocationImgDesktop} />
                        <source media="(min-width:768px)" srcSet={StationLocationImgTablet} />
                        <img src={StationLocationImgMobile} alt="" />
                    </picture>
                    <i class="icon-station-locations d-md-none"></i>
                    <i class="icon-station-locations2 d-none d-md-block"></i> */}
                    </ScrollAnimation>
                   </div>
                   
                   {/* <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                    <div className="nearest-stations">
                       <h2>Nearest Stations</h2>
                       <TransparentList
                                               latitude={props.property_latitude}
                                               longitude={props.property_longitude}
                                                />
                      
                   </div>
                   </ScrollAnimation> */}

                   </div>
               </Container>
           </section>
        </React.Fragment>
    )
}

export default StationLocations;